import React from "react";
import {
  RadarChart,
  Radar,
  PolarGrid,
  PolarAngleAxis,
  ResponsiveContainer,
} from "recharts";

// Props:
//   breakdown: {
//     skill_match: number,  // 0-100
//     experience: number,   // 0-100
//     verified: number,     // 0-100
//     portfolio: number,    // 0-100
//   }
//   isDark: boolean

const METRICS = [
  { key: "skill_match", label: "Skill Match" },
  { key: "experience",  label: "Experience" },
  { key: "verified",    label: "Verified" },
  { key: "portfolio",   label: "Portfolio" },
];

export default function MeritScoreChart({ breakdown = {}, isDark = false }) {
  const data = [
    { subject: "Skill Match", value: breakdown.skill_match ?? 0 },
    { subject: "Experience",  value: breakdown.experience  ?? 0 },
    { subject: "Verified",    value: breakdown.verified    ?? 0 },
    { subject: "Portfolio",   value: breakdown.portfolio   ?? 0 },
  ];

  const gridStroke = isDark
    ? "rgba(255,255,255,0.1)"
    : "rgba(0,0,0,0.1)";

  const tickFill = isDark ? "rgba(255,255,255,0.6)" : "#475569";

  const trackBg = isDark ? "rgba(255,255,255,0.1)" : "#e2e8f0";

  return (
    <div data-testid="merit-score-chart">
      {/* Radar chart */}
      <ResponsiveContainer width="100%" height={220}>
        <RadarChart data={data} margin={{ top: 10, right: 20, bottom: 10, left: 20 }}>
          <PolarGrid stroke={gridStroke} />
          <PolarAngleAxis
            dataKey="subject"
            tick={{ fill: tickFill, fontSize: 11 }}
          />
          <Radar
            name="Merit"
            dataKey="value"
            fill="rgba(249, 115, 22, 0.15)"
            stroke="#f97316"
            strokeWidth={2}
          />
        </RadarChart>
      </ResponsiveContainer>

      {/* Row metrics */}
      <div className="flex flex-col gap-2 mt-2">
        {METRICS.map(({ key, label }) => {
          const value = breakdown[key] ?? 0;
          return (
            <div key={key} className="flex items-center gap-3">
              <span
                className="text-xs w-24 shrink-0"
                style={{ color: isDark ? "rgba(255,255,255,0.6)" : "#475569" }}
              >
                {label}
              </span>
              {/* Progress bar track */}
              <div
                className="flex-1 rounded-full overflow-hidden"
                style={{ height: 4, background: trackBg }}
              >
                <div
                  className="h-full rounded-full"
                  style={{
                    width: `${value}%`,
                    background: "#f97316",
                    transition: "width 0.4s ease",
                  }}
                />
              </div>
              <span
                className="text-xs w-8 text-right shrink-0 font-medium tabular-nums"
                style={{ color: isDark ? "rgba(255,255,255,0.8)" : "#1e293b" }}
              >
                {value}%
              </span>
            </div>
          );
        })}
      </div>
    </div>
  );
}
